import React from 'react';

import BreederProfileCurrentLittersSectionContainer from '../BreederProfileCurrentLittersSectionContainer';
import BreederProfileLittersSectionContainer from '../BreederProfileLittersSectionContainer';
import BreederProfilePastPuppiesSectionContainer from '../BreederProfilePastPuppiesSectionContainer';

export default function BreederProfileLittersAndPuppiesTabContainer() {
  return (
    <div className="BreederProfileLittersAndPuppiesTabContainer flex flex-column gap-48">
      <BreederProfileCurrentLittersSectionContainer />
      <BreederProfilePastPuppiesSectionContainer />
      <BreederProfileLittersSectionContainer
        className="bg-white"
        mobileLayoutType="stacked"
      />
    </div>
  );
}
